export default "__VITE_ASSET__BGU4teP___"